import React from 'react';
import { Screen } from '../types';

const PurposeOfVisitScreen = ({ purpose, setPurpose, navigateTo }) => {
  const options = [
    { 
      id: 'Vacation / Tourism', 
      desc: 'Sightseeing, holidays, trekking, or recreational visits.', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
        </svg>
      ), 
      color: 'blue' 
    },
    { 
      id: 'Work / Employment', 
      desc: 'Contractual work, government duty, or private business.', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-10 0v-3.57a2 2 0 012-2h2V5a3 3 0 013-3h2a3 3 0 013 3v1h2zM9 6h2V5a1 1 0 00-1-1H9a1 1 0 00-1 1v1zM2 9h16v3H2V9zm2 6h12v1a2 2 0 01-2 2H6a2 2 0 01-2-2v-1z" clipRule="evenodd" />
        </svg>
      ), 
      color: 'orange' 
    }
  ];

  return (
    <div className="ilp-screen">
      <div className="ilp-header">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.ApplicantDetails)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Purpose of Visit</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-purpose-content">
        <div className="ilp-purpose-intro">
          <span className="ilp-step-badge">Step 3 of 5</span>
          <h1>Why are you visiting?</h1>
          <p>Select the category that best describes your trip.</p>
        </div>

        <div className="ilp-purpose-options">
          {options.map((opt) => (
            <button 
              key={opt.id}
              className={`ilp-purpose-option ${purpose === opt.id ? 'selected' : ''}`}
              onClick={() => setPurpose(opt.id)}
            >
              <div className={`ilp-purpose-icon ${opt.color} ${purpose === opt.id ? 'active' : ''}`}>
                {opt.icon}
              </div>
              <div className="ilp-purpose-text">
                <h4 className={purpose === opt.id ? 'active' : ''}>{opt.id}</h4>
                <p>{opt.desc}</p>
              </div>
              <div className={`ilp-radio ${purpose === opt.id ? 'checked' : ''}`}>
                {purpose === opt.id && <div className="ilp-radio-dot"></div>}
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="ilp-purpose-footer">
        <button 
          className="ilp-primary-btn full"
          onClick={() => navigateTo(Screen.ApplicationType)}
        >
          <span>Continue</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PurposeOfVisitScreen;

